import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaystackCallback() {
  const [params] = useSearchParams();
  const reference = params.get("reference") || params.get("trxref");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!reference) return;
    let cancelled = false;
    const check = async () => {
      try {
        const { data } = await axios.get(`${API}/paystack/verify/${reference}`);
        if (cancelled) return;
        setStatus(data);
        if (data.payment_status !== "paid" && attempts < 8) {
          setTimeout(() => setAttempts((a) => a + 1), 2000);
        }
      } catch (_e) {
        if (!cancelled) setStatus({ payment_status: "failed" });
      }
    };
    check();
    return () => {
      cancelled = true;
    };
  }, [reference, attempts]);

  const paid = status.payment_status === "paid";
  const failed = status.payment_status === "failed";
  const pending = !paid && !failed;

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-md w-full border border-border bg-card p-10 text-center">
        {pending && (
          <>
            <CircleNotch size={40} className="mx-auto animate-spin text-primary" />
            <h1 className="font-serif-display text-3xl mt-6">Verifying with Paystack</h1>
            <p className="text-sm text-muted-foreground mt-2 num">Ref {reference?.slice(-10)}</p>
          </>
        )}
        {paid && (
          <>
            <CheckCircle size={40} weight="fill" className="mx-auto text-primary" />
            <h1 className="font-serif-display text-3xl mt-6">Payment received.</h1>
            <p className="text-sm text-muted-foreground mt-2">
              A receipt journal has been posted to the ledger.
            </p>
          </>
        )}
        {failed && (
          <>
            <XCircle size={40} weight="fill" className="mx-auto text-destructive" />
            <h1 className="font-serif-display text-3xl mt-6">Payment failed.</h1>
          </>
        )}
        <Link
          to="/invoices"
          className="inline-block mt-8 rounded-sm border border-border px-6 py-2 text-xs uppercase tracking-widest font-mono hover:bg-muted transition-colors duration-200"
        >
          Back
        </Link>
      </div>
    </div>
  );
}
